import { render, staticRenderFns } from "./ProfileEditTabAttributes.vue?vue&type=template&id=2a124f90&scoped=true&"
import script from "./ProfileEditTabAttributes.vue?vue&type=script&lang=js&"
export * from "./ProfileEditTabAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditTabAttributes.vue?vue&type=style&index=0&id=2a124f90&lang=scss&scoped=true&"
import style1 from "./ProfileEditTabAttributes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a124f90",
  null
  
)

export default component.exports